<template>
    <div>
        <div class="flex flex-col items-center justify-center | lg:flex-row lg:items-start lg:justify-start">
            <button class="ffq-button | mb-3 | lg:mb-0" @click="handleNextPage" v-if="currentPage !== totalPages">{{ $t("Kies en naar stap :nextStep", {nextStep: (currentPage  + 2)}) }}</button>
            <div v-if="currentPage === totalPages" class="mb-5 text-center | lg:mb-0 lg:w-1/2">
                <button class="ffq-button ffq-button--submit | lg:w-full" @click="handleSubmitResults">{{ submitButtonText ? submitButtonText : $t('Opslaan en aanbeveling ontvangen') }}</button>
                <div v-if="submitButtonComment" class="text-xs text-center px-4 pt-1 text-gray-400 italic | lg:pt-0">{{submitButtonComment}}</div>
            </div>
            <div v-if="currentPage !== 1" class="flex items-center justify-center">
                <button class="ffq-gray-link | lg:py-4" @click="handlePreviousPage">{{$t('Terug naar vorige stap')}}</button>
            </div>
        </div>
        <GiveAwayBox v-if="currentPage === totalPages && display_give_away_box" />
    </div>

</template>
<style lang="scss">
    .ffq-button{
        @apply font-bold text-white py-4 px-5;
        background:var(--color-primary-light);
        border-radius: 0 25px 0 25px;

        &:hover{
            background:var(--color-primary);
        }
    }
    .ffq-gray-link{
        @apply text-gray-400 px-5;
    }
    .submit-giveaway-box{
        @apply border-dashed border-2 border-primary-light;

        &_text{
            p{
                @apply text-sm leading-5;
            }
            ul,ol{
                list-style: auto;
                margin-left: 1em;
                li{
                    @apply text-sm leading-5;
                }
            }
        }
    }
</style>
<script>
import { useStore } from 'vuex'
import {computed} from 'vue'
import GiveAwayBox from "./GiveAwayBox";

export default {
    name: "Navigation",
    components:{
        GiveAwayBox

    },
    data() {
        return {

        }
    },
    mounted() {

    },
    setup(props){
        const store = useStore()

        return {
            currentPage: computed(() => store.state.currentPageNumber),
            totalPages: computed(() => store.state.totalPageCount),

            pageIsValid: computed(() => store.state.pageIsValid),

            submitButtonText: computed(() => store.state.quizData.submit_page.text_submit_button),
            submitButtonComment: computed(() => store.state.quizData.submit_page.text_below_submit_button),
            display_give_away_box: computed(() => store.state.quizData.submit_page.display_give_away_box)
        }
    },
    methods:{
        handleNextPage(){
            // Validate answers on this page
            this.$store.commit('validatePage');

            if(this.pageIsValid){
                this.$store.commit('gotoNextPage');
            }
        },
        handlePreviousPage(){
            this.$store.commit('gotoPreviousPage');
        },
        handleSubmitResults(){
            // Validate answers on this page
            this.$store.commit('validatePage');

            if(this.pageIsValid){
                this.$store.dispatch('submitAnswersToServer');
            }
        }
    },
    props: {

    }
}
</script>
